import {
  Box,
  Button,
  Checkbox,
  Container,
  Flex,
  Table,
  Text,
} from '@mantine/core'
import ActionMenu from '@v2/commons/components/ActionMenu/ActionMenu.component'
import { openDeleteMembershipModal } from '@v2/domains/membership/components/DeleteMembershipModal.component'
import { openGenerateApiModal } from '@v2/domains/membership/components/GenerateApiModal.component'
import { openMembershipModal } from '@v2/domains/membership/components/MembershipModal.component'
import { IUserMembership } from '@v2/domains/membership/membership.types'

import { Icons } from 'src/common/components'
import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'

import styles from './membership-information.module.scss'

interface MembershipInformationProps {
  membership: IUserMembership
}

const MembershipInformation = ({ membership }: MembershipInformationProps) => {
  return (
    <Box my="md">
      <Flex
        justify="space-between"
        align="flex-start"
        className={styles.headerWrapper}
      >
        <Text fw={700} c="blue.5">
          Membership Information
        </Text>
      </Flex>

      <Flex justify="center">
        <Container mx="md" className={styles.flex1} my="xl">
          <Table withTableBorder highlightOnHover withColumnBorders>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Role</Table.Th>
                <Table.Th>Active</Table.Th>
                <Table.Th>API key</Table.Th>
                <Table.Th></Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {!!membership.id ? (
                <Table.Tr>
                  <Table.Td>{membership.role}</Table.Td>
                  <Table.Td>
                    <Flex justify="center">
                      <Checkbox
                        checked={membership.status === 'active'}
                        readOnly
                      />
                    </Flex>
                  </Table.Td>
                  <Table.Td>{!membership.hasAPIKey ? '-' : 'Active'}</Table.Td>
                  <Table.Td>
                    <Flex justify="center">
                      <ActionMenu
                        menuItems={[
                          {
                            label: 'Update',
                            color: 'blue',
                            icon: <Icons.Edit />,
                            onClick: () =>
                              openMembershipModal(
                                membership?.id ?? '',
                                membership.roleId ?? '',
                              ),
                            enable: true,
                          },
                          {
                            label: 'Add API Key',
                            color: 'blue',
                            icon: <Icons.Logout />,
                            onClick: () =>
                              openGenerateApiModal(membership?.id ?? ''),
                            enable: !membership.hasAPIKey,
                          },
                          {
                            label: 'Delete',
                            color: 'red',
                            icon: <Icons.Trash />,
                            onClick: () =>
                              openDeleteMembershipModal(membership?.id ?? ''),
                            enable: true,
                          },
                        ]}
                      />
                    </Flex>
                  </Table.Td>
                </Table.Tr>
              ) : (
                <Table.Tr>
                  <Table.Td>
                    <Button
                      fullWidth
                      variant="transparent"
                      size="md"
                      radius="xs"
                      leftSection={<Icons.Plus />}
                    >
                      Add new membership
                    </Button>
                  </Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>
        </Container>
      </Flex>
    </Box>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  MembershipInformation,
  'is_enable_leads_table',
  true,
)
